{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Ρυθμίσεις",
    "SUBMIT": "Ενημέρωση Ρυθμίσεων",
    "BACK": "Πίσω",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Δεν μπορεί να ενημερωθεί η ρύθμιση προσπαθήστε ξανά!",
      "SUCCESS": "Επιτυχής Ενημέρωση Ρυθμίσεων"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Διαγραφή",
        "DISMISS": "Άκυρο",
        "PLACE_HOLDER": "Παρακαλώ πληκτρολογήστε {accountName} για επιβεβαίωση"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Παρακαλώ διορθώστε τα λάθη της Φόρμας",
      "GENERAL_SECTION": {
        "TITLE": "Γενικές Ρυθμίσεις",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID Λογαριασμού",
        "NOTE": "Αυτό το ID απαιτείται αν δημιουργείτε μια ενσωμάτωση βασισμένη στο API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Ονομασία Λογαριασμού",
        "PLACEHOLDER": "Η ονομασία του Λογαριασμού σας",
        "ERROR": "Παρακαλώ συμπληρώστε ένα έγκυρο όνομα λογαριασμού"
      },
      "LANGUAGE": {
        "LABEL": "Γλώσσα ιστοσελίδας",
        "PLACEHOLDER": "Το όνομα του Λογαριασμού",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Τομέας (domain) του εισερχόμενου email",
        "PLACEHOLDER": "Ο τομέας στον οποίο θα λαμβάνετε τα emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email Υποστήριξης",
        "PLACEHOLDER": "To email υποστήριξης της εταιρίας σας",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Ενημέρωση",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Η συνέχεια της συνομιλίας με emails έχει ενεργοποιηθεί για τον λογαριασμό.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Τώρα μπορείτε να λαμβάνετε emails στον τομέα (domain) σας."
      }
    },
    "UPDATE_CHATWOOT": "Μια ενημέρωση {latestChatwootVersion} για το Chatwoot είναι διαθέσιμη. Ενημερώστε την εφαρμογή σας.",
    "LEARN_MORE": "Μάθετε περισσότερα",
    "PAYMENT_PENDING": "Your payment is pending. Please update your payment information to continue using Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Your account has exceeded the usage limits, please upgrade your plan to continue using Chatwoot",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Πάτησε enter για επιλογή",
      "ENTER_TO_REMOVE": "Πάτησε enter για αφαίρεση",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Επιλέξτε ένα",
      "SELECT": "Επιλογή"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Ειδοποιήσεις",
    "MARK_ALL_DONE": "Όλες ολοκληρωμένες",
    "DELETE_TITLE": "διαγράφηκε",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Μη Αναγνωσμένες Ειδοποιήσεις",
      "ALL_NOTIFICATIONS": "Προβολή όλων των ειδοποιήσεων",
      "LOADING_UNREAD_MESSAGE": "Φόρτωση μη αναγνωσμένων ειδοποιήσεων...",
      "EMPTY_MESSAGE": "Δεν έχετε μη αναγνωσμένες ειδοποιήσεις"
    },
    "LIST": {
      "LOADING_MESSAGE": "Φόρτωση ειδοποιήσεων...",
      "404": "Καμία Ειδοποίηση",
      "TABLE_HEADER": [
        "Όνομα",
        "Αριθμός Τηλεφώνου",
        "Συζητήσεις",
        "Τελευταία επικοινωνία"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Νέα συνομιλία",
      "conversation_assignment": "Η Συνομιλία Ανατέθηκε",
      "assigned_conversation_new_message": "Νέο Μήνυμα",
      "participating_conversation_new_message": "Νέο Μήνυμα",
      "conversation_mention": "Αναφορά",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Εκτός",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Ανανέωση"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Αναζήτηση ή μετάβαση σε",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Γενικά",
      "REPORTS": "Αναφορές",
      "CONVERSATION": "Συνομιλία",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Αλλαγή Αναδόχου",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Αλλαγή Ομάδας",
      "SNOOZE_CONVERSATION": "Αναβολή Συνομιλίας",
      "ADD_LABEL": "Προσθήκη ετικέτας στη συνομιλία",
      "REMOVE_LABEL": "Αφαίρεση ετικέτας από την συνομιλία",
      "SETTINGS": "Ρυθμίσεις",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Μεταβείτε στον Πίνακα Συνομιλίων",
      "GO_TO_CONTACTS_DASHBOARD": "Μετάβαση στον Πίνακα Επαφών",
      "GO_TO_REPORTS_OVERVIEW": "Μετάβαση στις Αναφορές",
      "GO_TO_CONVERSATION_REPORTS": "Μετάβαση στις Αναφορές Συνομιλίας",
      "GO_TO_AGENT_REPORTS": "Μεταβείτε στις Αναφορές Πράκτορα",
      "GO_TO_LABEL_REPORTS": "Μεταβείτε στις Αναφορές Ετικετών",
      "GO_TO_INBOX_REPORTS": "Μεταβείτε στις Αναφορές Εισερχομένων",
      "GO_TO_TEAM_REPORTS": "Μεταβείτε Αναφορές Ομάδας",
      "GO_TO_SETTINGS_AGENTS": "Μεταβείτε στις Ρυθμίσεις Πράκτορα",
      "GO_TO_SETTINGS_TEAMS": "Μεταβείτε στις ρυθμίσεις ομάδας",
      "GO_TO_SETTINGS_INBOXES": "Μετάβαση στις Ρυθμίσεις Εισερχομένων",
      "GO_TO_SETTINGS_LABELS": "Μεταβείτε στις Ρυθμίσεις Ετικετών",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Μεταβείτε στις ρυθμίσεις τυποποιημένων απαντήσεων",
      "GO_TO_SETTINGS_APPLICATIONS": "Μετάβαση στις ρυθμίσεις εφαρμογής",
      "GO_TO_SETTINGS_ACCOUNT": "Μεταβείτε στις ρυθμίσεις λογαριασμού",
      "GO_TO_SETTINGS_PROFILE": "Μετάβαση στις ρυθμίσεις προφίλ",
      "GO_TO_NOTIFICATIONS": "Μετάβαση στις ειδοποιήσεις",
      "ADD_LABELS_TO_CONVERSATION": "Προσθήκη ετικέτας στη συνομιλία",
      "ASSIGN_AN_AGENT": "Εκχώρηση πράκτορα",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Εκχώρηση ομάδας",
      "MUTE_CONVERSATION": "Σίγαση Συνομιλίας",
      "UNMUTE_CONVERSATION": "Επαναφορά Συνομιλίας",
      "REMOVE_LABEL_FROM_CONVERSATION": "Αφαίρεση ετικέτας από την συνομιλία",
      "REOPEN_CONVERSATION": "Άνοιγμα συνομιλίας",
      "RESOLVE_CONVERSATION": "Επίλυση Συνομιλίας",
      "SEND_TRANSCRIPT": "Στείλτε μεταγραφή της συνομιλίας",
      "SNOOZE_CONVERSATION": "Αναβολή Συνομιλίας",
      "UNTIL_NEXT_REPLY": "Μέχρι την επόμενη απάντηση",
      "UNTIL_NEXT_WEEK": "Έως την επόμενη εβδομάδα",
      "UNTIL_TOMORROW": "Μέχρι αύριο",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Φόρτωση Εφαρμογής Dashboard..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "πατήστε εδώ"
  }
}
